import { call, put, takeEvery } from "redux-saga/effects"
import { AppConfiguration } from "config"
import { UPDATE_CLIENT_USER } from "./actionTypes"
import { bsh_getAdminUserDetails } from "helpers/sf_browser_storage_helper";
import { getOldAdminUsers } from "store/admin/users/actions";
import {
  genericPutRequest,
} from "../../helpers/sf_backend_helper"
import { updateClientUserError, updateClientUserSuccess } from "./actions";
import { getAccountSuccess } from "store/actions";
function* onUpdateClientUser({ payload: client_user }) {
  try {
    let user_auth = bsh_getAdminUserDetails();
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/accounts/${client_user?.id}`,
      {
        body: JSON.stringify(client_user),
        headers: {
          Authorization: user_auth.token,
          account_id: client_user?.id,
          'Content-Type': 'application/json',
        }
      }
    )
    yield put(getAccountSuccess(response));
    yield put(updateClientUserSuccess(response))
    yield put(getOldAdminUsers())
  } catch (error) {
    yield put(updateClientUserError(error))
  }
}

function* UpdateClientUserSaga() {
  yield takeEvery(UPDATE_CLIENT_USER, onUpdateClientUser)
}

export default UpdateClientUserSaga
